/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { css } from 'styled-components';
import { UitkButtonSize } from 'uitk-react-button';
import Layout from 'src/components/common/theme/Layout';
import { ModuleProps } from 'src/components/common/module-util';
import { getDeviceImage, tinyImageForProductCard } from 'src/components/common/theme/component';
import { checkValue, LightenDarkenColor, getDefaultValue, onImageLoad } from 'src/components/common/helper';
import {
  mediaQueries,
  setFontFormat,
  titleWeight,
  setFontSizeByModule,
  textColorGlobal,
  setCustomizedStyles,
} from 'src/components/common/theme/component-styles';
import { PrimaryButton, PrimaryButtonProps } from 'src/components/common/ui/button/button';
import { SlickSlider } from 'src/components/common/modules/carousel/slick/slick-carousel';
import { Typo } from 'src/components/common/ui';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { CopyrightWithGradientComponent, CopyrightCameraProps } from 'src/components/common/modules/copyright-with-gradient/code-split/copyright-with-gradient-component';
import { Viewport, ViewSmall, ViewLarge, ViewMedium } from '@shared-ui/viewport-context';

const ProductIntegrationComponent = (props: ModuleProps) => {
  const {
    data: {
      module,
      backgroundColor,
      productItemSummaryCopySizeDesktop,
      productItemSummaryCopySizeMobile,
      productItemSummaryCopyWeight,
      productItemCtaColor,
      productItemCtaCopyColor,
      productList,
      summary,
      summaryCopySizeDesktop,
      summaryCopySizeMobile,
      summaryCopyWeight,
      textColor = 'dark',
      title,
      productItemTextColor,
      modulePadding,
      moduleStyle: variationStyle,
      moduleTextStyle = 'Text-left',
      turnOffMobileDropShadow
    },
    articleStyle,
    isSpotlightPage,
    id,
    exClass
  } = props;

  let theme2coloredstyle = '';
  const leftbarColor = '#D32F2F';
  const rightbarColor = '#8EC089';
  const productTitleAlign = props?.data?.moduleTextStyle === "Text-left"?"flex-start":"center"
  let newModuleStyle = '';
  if (checkValue(variationStyle) && variationStyle.toLowerCase() === "style-3") newModuleStyle = 'item-style'
  else if (checkValue(variationStyle) && variationStyle.toLowerCase() === "style-6") newModuleStyle = 'style-6'
  const turnOffMobileShadow = checkValue(turnOffMobileDropShadow) && turnOffMobileDropShadow.toLowerCase() === "false";

  const settingsNormal = {
    arrows: true,
    slidesToShow: 2,
    infinite: false,
    initialSlide: 0,
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          slidesToShow: 2,
          infinite: false,
          dots: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
          infinite: false,
          dots: true,
        },
      },
    ],
  };

  const gaTracking = {
    eventCategory: 'Slick carousel',
    eventAction: ' Product integration - carousel',
    eventLabel: 'slide-',
  };

  const settingswebflow = {
    arrows: true,
    slidesToShow: 2,
    infinite: false,
    initialSlide: 0,
    dots: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          arrows: true,
          infinite: false,
          dots: true,
        },
      },
    ],
  };

  const settings = settingswebflow;

  const tileCards = (isMobile = false) => {
    if (checkValue(productList) && typeof productList !== 'string') {
      return productList?.map((content: any, index: number) => {
        const {
          backgroundColor,
          cTACopy,
          cTALink,
          cTALinkSubpage,
          image,
          //module,
          moduleStyle,
          summary,
          title,
          turnOffGradient,
          imageDescription = '',
          barColorLeft,
          barColorRight,
          moduleTheme,
          imageCopyright,
          logoOverlay,
          openUrlInNewTab,
          subHeadline,
          topLeftRibbonColor,
          rightRibbonColor,
          infoText
        } = content;

        switch (moduleTheme) {
          case 'Theme 2 - Colored bars':
            theme2coloredstyle = 'theme2coloredbars';
            break;
          case 'Theme 1 - Plain':
            theme2coloredstyle = '';
            break;
          default:
            theme2coloredstyle = '';
        }

        const productImage = checkValue(image)
          ? getDeviceImage(image, 'product-image')
          : 'https://mesocp3.azureedge.net/media/c32fmcus/static-img.jpg';
        const modulestyle = checkValue(moduleStyle) ? (moduleStyle === 'Text-right' ? 'right' : 'left') : 'left';
        const backgroundIntitle: any = checkValue(backgroundColor) ? { backgroundColor: backgroundColor } : {};

        const tinyImage = tinyImageForProductCard(productImage);
        /*
         * Button URL Create
         */
        let cpCTAUrl = checkValue(cTALink) ? cTALink : '';
        if (typeof cTALinkSubpage !== 'string') {
          cpCTAUrl = checkValue(cTALinkSubpage) && checkValue(cTALinkSubpage[0]) ? cTALinkSubpage?.[0]?.url : cpCTAUrl;
          cpCTAUrl = cpCTAUrl.endsWith('/') ? cpCTAUrl.slice(0, -1) : cpCTAUrl;
        }
        const clickEventTarget =
          (checkValue(openUrlInNewTab) && openUrlInNewTab === "True") ? '_blank' : '_self';

        const imageAltText = getDefaultValue(imageDescription, `Product Image ${index + 1}`);

        const primaryButtonProps: PrimaryButtonProps = {
          text: cTACopy,
          tag: 'button',
          gaTracking: {
            eventCategory: 'Button Click',
            eventAction: 'Product-integration',
            eventLabel: `${cTACopy}`,
          },
          url: cpCTAUrl,
          target: clickEventTarget,
          size: UitkButtonSize.LARGE,
        };

        const copyrightCameraProps: CopyrightCameraProps = {
          copyrightText: imageCopyright,
          position: "br",
          iconSize: "sm"
        };

        const logoOverlaySrc = getDeviceImage(logoOverlay, "desktop")
        let moduleVariationInclude = checkValue(variationStyle) && variationStyle.toLowerCase() === "style-2" ? "variation-include" : '';
        let moduleVariationExclude = checkValue(variationStyle) && variationStyle.toLowerCase() === "style-2" ? 'variation-exclude' : '';
        if (checkValue(variationStyle) && variationStyle.toLowerCase() === "style-5") {
          moduleVariationInclude = checkValue(variationStyle) && variationStyle.toLowerCase() === "style-5" ? "variation-include" : '';
          moduleVariationExclude = checkValue(variationStyle) && variationStyle.toLowerCase() === "style-5" ? 'variation-exclude' : '';
        }

        const bottomContent = [cTACopy, cpCTAUrl, infoText].some((el:string) => checkValue(el));

        return (
          <div
            className={`tile ${productList.length > 1 ? 'tile-gap' : ''} 
            ${modulestyle}`}
            key={`tile-${index}`}
            style={backgroundIntitle}
          >
            {checkValue(moduleVariationInclude) && isMobile ? <div className={`product-integration-panel-title ${theme2coloredstyle} ${moduleVariationInclude}`}>
              <Typo.HTMLText tag="h2" exClass='override-heading-font-family'>{title}</Typo.HTMLText>
              {checkValue(subHeadline) && (
                <Typo.HTMLText tag="h3" exClass='override-heading-font-family'>{subHeadline}</Typo.HTMLText>
              )}
            </div> : null}
            <div className={`product-integration-panel-image ${theme2coloredstyle} ${turnOffMobileShadow ? 'product-integration-panel-image--shadow' : ''}`}>
              <div className="colorbar-wrapper">
                <CopyrightWithGradientComponent {...copyrightCameraProps} />
                <div className='prod-panel-image-container'>
                  <img
                    src={tinyImage}
                    data-placeholder-background="#e5e5e5"
                    alt={imageAltText}
                    className="lozad"
                    onLoad={(e) => {
                      onImageLoad(e.currentTarget, productImage);
                    }}
                  />
                  {checkValue(logoOverlaySrc) && (<img src={logoOverlaySrc} className="prod-integration-ovelary-image" data-placeholder-background="#e5e5e5" />)}
                </div>
                <div className="colorbar colorbar-top-right" style={{ background: barColorRight }}></div>
                <div className="colorbar colorbar-bottom-left" style={{ background: barColorLeft }}></div>
                <div className="colorbar colorbar-top-left" style={{ background: topLeftRibbonColor }}></div>
                <div className="colorbar colorbar-bottom-right" style={{ background: rightRibbonColor }}></div>
              </div>
              {checkValue(turnOffGradient) && (turnOffGradient === 'False' || turnOffGradient === false) && (
                <div className="gradient"></div>
              )}
            </div>
            <div className={`product-integration-panel-title ${theme2coloredstyle}`}>
              {(!isMobile || !checkValue(moduleVariationInclude)) && <>
                <Typo.HTMLText tag="h2" exClass={`override-heading-font-family ${moduleVariationExclude} ${checkValue(moduleTextStyle) ? moduleTextStyle.toLowerCase() : ''}`}>{title}</Typo.HTMLText>
                {checkValue(subHeadline) && (<div className="subhead-wrapper">
                  <h3 className={`override-heading-font-family ${moduleVariationExclude}`}>
                    <UitkIcon
                      name="place"
                      size={UitkIconSize.SMALL}
                    />
                    <span dangerouslySetInnerHTML={{ __html: subHeadline }} />
                  </h3>
                </div>)}
              </>}
              {checkValue(summary) && <Typo.HTMLText tag="p" exClass={`${checkValue(moduleTextStyle) ? moduleTextStyle.toLowerCase() : ''} ${!bottomContent ? 'no-bottom-space' : ''}`}>{summary}</Typo.HTMLText>}
              {checkValue(cTACopy) && checkValue(cpCTAUrl) ?
                <PrimaryButton
                  {
                    ...{...primaryButtonProps,
                    exClass: 'desktop btn ga4-product-int-btn-signup fit-content-button product-integration-btn'
                  }}
                /> : null
              }
              {checkValue(infoText) && (<div className="infotext desktop">
                <Typo.HTMLText tag="p" exClass={`infotext-content`}>{infoText}</Typo.HTMLText>
              </div>)}
            </div>
            {checkValue(cTACopy) && checkValue(cpCTAUrl) ? (
              <div className="product-integration-panel-title-mobile mobile">
                <PrimaryButton {...{ ...primaryButtonProps, exClass: 'btn' }} />
              </div>
            ) : null}
            {checkValue(infoText) && (<div className="infotext mobile">
              <Typo.HTMLText tag="p" exClass={`infotext-content`}>{infoText}</Typo.HTMLText>
            </div>)}
          </div>
        );
      });
    } else {
      return null;
    }
  };

  const moduleCss = () => {
    const backgroundColorModule = checkValue(backgroundColor) ? backgroundColor : '#f3f3f3';
    const productItemCopySizeDesktopMap = setFontSizeByModule(
      module,
      'productItemSummaryCopySizeDesktop',
      productItemSummaryCopySizeDesktop
    );
    const productItemCopySizeMobile = setFontSizeByModule(
      module,
      'productItemSummaryCopySizeMobile',
      productItemSummaryCopySizeMobile
    );

    const copyColor = checkValue(textColor) ? textColorGlobal[textColor.toLowerCase()] : '#ffffff';

    const summaryCopySizeDesktopMap = setFontSizeByModule(module, 'summaryCopySizeDesktop', summaryCopySizeDesktop);
    const summaryCopySizeMobilepMap = setFontSizeByModule(module, 'summaryCopySizeMobile', summaryCopySizeMobile);

    let primaryDarkColor = '';
    if (checkValue(productItemCtaColor)) {
      primaryDarkColor = LightenDarkenColor(productItemCtaColor, -0.1);
    }

    return `
    ${setFontFormat(
      '.product-integration-panel-info p.cms-typo',
      summaryCopySizeDesktopMap,
      titleWeight(summaryCopyWeight),
      copyColor
    )};
      ${setFontFormat(
      '.product-integration-panel-title p.cms-typo',
      productItemCopySizeDesktopMap,
      titleWeight(productItemSummaryCopyWeight),
      //copyColor
      '#000000'
    )};      
      @media only screen and (max-width: ${mediaQueries.tab}) {
        ${setFontFormat(
      '.product-integration-panel-info p.cms-typo',
      summaryCopySizeMobilepMap,
      titleWeight(summaryCopyWeight),
      copyColor
    )}
        ${setFontFormat(
      '.product-integration-panel-title p.cms-typo',
      // productItemCopySizeMobilepMap,
      productItemCopySizeMobile,
      titleWeight(productItemSummaryCopyWeight),
      //copyColor
      '#000000'
    )};
      }
      .product-integration-panel{
        background-color: ${backgroundColorModule} !important ;
        &.theme2coloredbars{
          .product-integration-panel-image .colorbar-wrapper .colorbar-right{
            background: ${rightbarColor};
          }
          .product-integration-panel-image .colorbar-wrapper .colorbar-left{
            background: ${leftbarColor};
          }
        }
      }
      ${setCustomizedStyles(`productIntegrationModule${checkValue(isSpotlightPage) ? '-spotlight' : ''}`, articleStyle)};

      
      .uitk-button-primary{              
        background-color:${checkValue(productItemCtaColor) ? productItemCtaColor : ''} !important;
        border-color: ${checkValue(productItemCtaColor) ? productItemCtaColor : ''} !important;
        color: ${checkValue(productItemCtaCopyColor) ? productItemCtaCopyColor : ''} !important;
        &:hover{
          background-color: ${primaryDarkColor} !important;
          border-color: ${primaryDarkColor} !important;
        }
      }
      ${checkValue(productItemTextColor) ?
        `
        .product-integration-panel-title {
          h2.cms-typo {
            color: ${productItemTextColor} !important;
          }
          h3.cms-typo, h3 {
            color: ${productItemTextColor} !important;
          }
          p.cms-typo, .infotext .infotext-content a {
            color: ${productItemTextColor} !important;
          }
        }
        .product-integration-panel-mobile{
          .infotext .infotext-content, .infotext .infotext-content a {
            color: ${productItemTextColor} !important;
          }
        }
        .product-integration-panel-title .subhead-wrapper {
          h3, svg {
            color: ${productItemTextColor} !important;
          }
        }
        ` : ''}
        ${checkValue(modulePadding) && modulePadding.toLowerCase() === 'xlarge' ?
        `
        .product-integration-panel .container {
          padding-top:60px;
          padding-bottom:60px;      
          @media only screen and (max-width: 1024px) {
            padding-top:30px;
            padding-bottom:30px;      
          }    
        }
        
        .product-integration-panel-title {
          padding-left:60px;
          padding-right:60px;
        }
        ` : ''}
        ${checkValue(modulePadding) && modulePadding.toLowerCase() === 'large' ?
        `
        .product-integration-panel .container {
          padding-top:152px;
          padding-bottom:168px;          
        }
        
        .product-integration-panel-title {
          padding-left:60px;
          padding-right:60px;
        }
        ` : ''}
        ${checkValue(modulePadding) && modulePadding.toLowerCase() === 'medium' ?
        `
        .product-integration-panel .container {
          padding-top:128px;
          padding-bottom:128px;
        }
        
        .product-integration-panel-title {
          padding-left:60px;
          padding-right:60px;
        }
        @media only screen and (min-width: 1300px) {
          .product-integration-panel-title.theme2coloredbars {
            padding: 20px 24px 20px 101px !important;
          }
        }
        ` : ''}

        ${checkValue(productTitleAlign) ?
       ` .product-integration-panel-wrapper {
          align-items: ${productTitleAlign} !important;

          @media only screen and (max-width: 992px) {
            align-items: center !important;
          }
       }:`:null}
    `;
  };

  const tileList = tileCards(false);
  const mobileTileList = tileCards(true);
  const modulestyleMobile = checkValue(productList[0]?.moduleStyle)
    ? productList[0]?.moduleStyle === 'Style-right'
      ? 'bottom'
      : 'top'
    : 'top';

  return (
    <>
      <Layout
        HtmlTag="section"
        className={`product-integration-section ${newModuleStyle} ${checkValue(exClass) ? exClass : ''}`}
        css={css`
          ${moduleCss()}
        `}
        id={id}
      >
        <div className={`product-integration-panel container-fluid 
        ${checkValue(variationStyle) && `panel-${variationStyle.toLowerCase()}`} 
        ${isSpotlightPage ? 'spotlight-wrapper' : ''} 
        ${(checkValue(modulePadding) && modulePadding.toLowerCase() === 'medium') ? 'panel-style-aux' : ''}
        `}>
          <div className="container">
            <div className="product-integration-panel-wrapper">
              {(checkValue(title) || checkValue(summary)) && (
                <div className="product-integration-panel-info">
                  {checkValue(title) && <Typo.HTMLText tag="h2" exClass='override-heading-font-family'>{title}</Typo.HTMLText>}
                  {checkValue(summary) && <Typo.HTMLText tag="p">{summary}</Typo.HTMLText>}
                </div>
              )}
              {checkValue(tileList) && (
                <>
                  <Viewport>
                    <ViewLarge>
                      <div className="product-integration-panel-single desktop">{tileList}</div>
                    </ViewLarge>
                    <ViewMedium>
                      {tileList.length > 1 ? (
                        <div className="product-integration-panel-mobile">
                          <SlickSlider settings={settings} gaTracking={gaTracking}>
                            {tileList}
                          </SlickSlider>
                        </div>
                      ) : (
                        <div className={`product-integration-panel-mobile single ${modulestyleMobile}`}>{tileList}</div>
                      )}
                    </ViewMedium>
                    <ViewSmall>
                      {tileList.length > 1 ? (
                        <div className="product-integration-panel-mobile">
                          <SlickSlider settings={settings} gaTracking={gaTracking}>
                            {mobileTileList}
                          </SlickSlider>
                        </div>
                      ) : (
                        <div className={`product-integration-panel-mobile single ${modulestyleMobile}`}>{mobileTileList}</div>
                      )}
                    </ViewSmall>
                  </Viewport>
                </>
              )}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ProductIntegrationComponent;